export const firebaseConfig = {
  apiKey: 'AIzaSyAyzouxR5ypLe6KY55U2rOF6elSm3XdpEw',
  authDomain: import.meta.env.VITE_BIZ_FIREBASE_DOMAIN,
  projectId: 'rocnovel-ecf4b',
  storageBucket: 'rocnovel-ecf4b.firebasestorage.app',
  messagingSenderId: '250984910071',
  appId: '1:250984910071:web:f52bbd8a2ec7f00c0117f2',
  measurementId: 'G-XSELTNYMY0',
}
